module.exports = __webpack_public_path__ + "img/05_uk.869611c3.svg";